import { useState, useEffect } from 'react';

// FIXME:
// devでconsoleにエラー出るので基本的には使用しない方向で消していく
// メディアクエリで代替する
export const useResponsive = () => {
  const [isDesktop, setDesktop] = useState(false);

  useEffect(() => {
    const checkDesktop = () => {
      setDesktop(window.matchMedia('(min-width: 768px)').matches);
    };

    checkDesktop();

    const mediaQuery = window.matchMedia('(min-width: 768px)');
    const handleChange = (e: MediaQueryListEvent) => {
      setDesktop(e.matches);
    };

    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return { isDesktop };
};
